import classNames from 'clsx';
import styles from '../../embed.style';
import type { VideoEmbedADT } from '../../type';

export function vimeo(input: VideoEmbedADT): VideoEmbedADT {
  // 已经被上游处理过就直接原样输出
  if (!(input instanceof URL)) return input;
  const host = input.host;

  if (host === 'vimeo.com') {
    const pathname = input.pathname;
    const id = pathname.match(/\/(.*)/)?.[1];
    if (!id) return input;
    return (
      <div className={classNames('w-full h-full', styles.iframeEmbed)}>
        <iframe
          className={styles.iframe}
          src={`https://player.vimeo.com/video/${id}`}
          width="100%"
          height="100%"
          frameBorder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
          loading="lazy"
        />
      </div>
    );
  }

  return input;
}
